<template>
<div class="skipDetail" v-if="details">
     <p class="title">今日跳绳一览</p>
     <div class="con" v-if='details.todayInfo'>
          <div class="view wid marb">
              <img src='@/assets/img/step/re6.png' class="imgs">
              <p class="txt">{{details.todayInfo.skipTimes||0}}<br><span class="gray">总时长（分钟）</span></p>
          </div>
          <div class="view marb">
              <img src='@/assets/img/step/re7.png' class="imgs">
              <p class="txt">{{details.todayInfo.skipNum||0}}<br><span class="gray">总个数</span></p>
          </div>
          <div class="view wid">
              <img src='@/assets/img/step/re8.png' class="imgs">
              <p class="txt">{{details.todayInfo.skipAvgNums||0}}<br><span class="gray">速率（个/分钟）</span></p>
          </div>
          <div class="view">
              <img src='@/assets/img/step/re9.png' class="imgs">
              <p class="txt">{{details.todayInfo.continueDay||0}}<br><span class="gray">连续（天）</span></p>
          </div>
     </div>

     <p class="title flex-between">今日跳绳记录<span class="gray" @click="gotoUrl('stuSkipList')">更多<van-icon name="arrow" /></span></p>
     <template v-if='details.skipInfo'>
     <div class="con skipInfo" v-if="details.skipInfo.freeMode">
        <p class="txt">计时跳</p>
        <div class="flex-between">
           <p><span class='bold'>{{details.skipInfo.freeMode.skipNum}}</span><br><span class="gray">数量（个）</span></p>
           <p><span class='bold'>{{details.skipInfo.freeMode.skipAvgNums}}</span><br><span class="gray">速率（个/分钟）</span></p>
           <p><span class='bold'>{{details.skipInfo.freeMode.skipTimes	}}</span><br><span class="gray">时长（分钟）</span></p>
        </div>
     </div>
     <div class="con skipInfo" v-if="details.skipInfo.classMode">
        <p class="txt">随堂练习</p>
        <div class="flex-between">
           <p><span class='bold'>{{details.skipInfo.classMode.skipNum}}</span><br><span class="gray">数量（个）</span></p>
           <p><span class='bold'>{{details.skipInfo.classMode.skipAvgNums}}</span><br><span class="gray">速率（个/分钟）</span></p>
           <p><span class='bold'>{{details.skipInfo.classMode.skipTimes	}}</span><br><span class="gray">时长（分钟）</span></p>
        </div>
     </div>
     </template>
     <template v-else>
       <div class="con">
         <div class='noData' v-if="text" style="padding-top:.3rem"><div><img :src='require("@/assets/img/nodata.png")'><br />{{text}}</div></div>
       </div>
     </template>
     
     <template v-if="details.skipAvgNumsList.length>0">
     <p class="title">近100次跳绳速率趋势（个/分钟）</p>
     <div class="con" style="padding:.15rem .05rem 0.1rem;">
         <chart id='charts1' :option='option1'></chart>
     </div>
     </template>

     <p class="title">跳绳统计</p>
     <div class="con" style="padding:.15rem .05rem 0.1rem;">
         <div class="tab flex-center"><p :class='{active:cur==1}' @click="getChart(1)">日</p><p :class='{active1:cur==2}' @click="getChart(2)">月</p></div>
         <chart id='charts2' :option='option2'></chart>
     </div>
</div>
</template>
<script>
import {getSkipInfo} from "@/api/api.report";
import chart from './components/commonChart.vue';
  export default {
    data() {
      return {
        list:'',
        details:'',
        text:'',
        option1:{},
        option2:{},
        cur:1,//1日 2月
      }
    },
    components:{chart},
    created(){
     this.getDetail();
     
    },
    methods: {
      getDetail(){
         getSkipInfo({
              studentId:this.loginUser.studentId
           }).then((data) => {
            if (data && data.result) {
                 this.details=data.result;
                 this.getArea();
                 this.getChart(1);
                 if(this.details.skipInfo) return
                 this.text='暂无数据';
            }
           })
      },
      getArea(){
          let arr=this.details.skipAvgNumsList.map(item=>parseInt(item));
          
          var chart = {
            type: "area",
            backgroundColor: "#fff",
            
          };
          // 标题
          var title = {text: ""};
          // X 轴
          var xAxis = {
            crosshair: true,
            categories:[],
            labels: {
              enabled: false,
              reserveSpace: false,  // 轴标签不占用空间
            }
          };
          // Y 轴
          var yAxis = {
            title: {
              text: "",
            },
            gridLineColor:'#fff',
            lineWidth: 1,
            allowDecimals: false,
          };
          var plotOptions={
            area: {
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1
                },
                stops: [
                  [0, '#3B88FA'],
                  [1, '#fff']
                ]
              },
              threshold: null
            }
          };
          var tooltip={
                formatter: function () {
                  return '跳绳速率：' + this.y + '</b>个';
                }
              };
          var credits = {
            enabled: false
          };
          var legend = {
            enabled: false
          };
          var series = [
            {
              name: "跳绳速率",
              data: arr,
              color: "#3B88FA",
            
            }
          ];

          var json = {
                exporting: {
                  enabled: false
                }
             };
          json.chart = chart;
          json.title = title;
          json.xAxis = xAxis;
          json.yAxis = yAxis;
          json.tooltip=tooltip;
          json.credits = credits;
          json.legend = legend;
          json.plotOptions = plotOptions;
          json.series = series;
          this.option1 =json;
      },
      getChart(index){
          this.cur=index;
          let x=[],arr=[],num=0;
          if(this.cur==1){//日
            this.details.dateStatisticsList.forEach(item=>{
              let time=item.skipDate.split('-');
                x.push(time[1]+'/'+time[2]);
                arr.push(item.skipNum);
                if(item.skipNum==0){
                  num++;
                }
                
            });
          }else{
            this.details.monthStatisticsList.forEach(item=>{
                x.push(item.skipDate);
                arr.push(item.skipNum);
                if(item.skipNum==0){
                  num++;
                }
            });
          }
          var chart = {
            type: "column",
          };
          // 标题
          var title = {
            text: ""
          };
          // X 轴
          var xAxis = {
            crosshair: true,
            categories: x,
          };
          // Y 轴
          var yAxis = {
            title: {
              text: "",
            },
            gridLineColor:'#fff',
            lineWidth: 1,
            allowDecimals: false,
          };
         
          var credits = {
            enabled: false
          };
          var legend = {
            enabled: false
          };
          var series = [
            {
              name: "跳绳统计",
              data: arr,
              color: "#52A5FF",
            
            }
          ];

          var json = {
                exporting: {
                  enabled: false
                }
             };
          json.chart = chart;
          json.title = title;
          json.xAxis = xAxis;
          json.yAxis = yAxis;
          // json.plotOptions = plotOptions;
          json.credits = credits;
          json.legend = legend;
          json.series = series;
          if(arr.length==num){
            json.yAxis.labels={enabled: false}
          }
          this.option2 = json;
      },
    },
  }
</script>
<style lang="scss" >
.skipDetail{
    padding:.12rem;
    .title{
      color: #333;
      font-size: .14rem;
      padding-top: .2rem;
      &:first-child{
        padding-top: 0rem;
      }
    }
    .gray{
            font-size: .12rem;
     }
    .con{
      margin-top: .13rem;
      background:#fff;
      border-radius: 12px;
      padding:.2rem .15rem;
      
      .view{
        // width: 38%;
        display: inline-block;
        &.marb{
           margin-bottom: .16rem;
        }
        &.wid{
          width:60%;
        }
        .imgs{
          width: .4rem;
          height: .4rem;
        }
        .txt{
          display: inline-block;
          margin-left: .1rem;
          vertical-align: super;
        }
      }
      &.skipInfo{
          padding: .2rem .26rem;
          text-align: center;
          .txt{
            margin-bottom: .2rem;
            text-align: left;
          }
          .bold{
            font-weight: 600;
            font-size: .18rem;
            color:#333;
            margin-bottom: .1rem;
          }
      }
    }
    .tab{
      border: 1px solid #d9d9d9;
      border-radius: 6px;
      width: 140px;
      margin: .1rem auto;
      text-align: center;
      p{
        width:70px;
        height: .3rem;
        line-height: .3rem;
      }
      .active,.active1{
        background: #3B88FA;
        color:#fff;
        border-radius: 6px 0px 0px 6px;
      }
      .active1{
        border-radius:0px 6px 6px 0px;
      }
    }
}
</style>